// pages/Contact/index.jsx
import React from "react";
import { Container } from "../../styles/components";
import {
	MapPin,
	Phone,
	Mail,
	Instagram,
	Clock,
	MessageCircle,
} from "lucide-react";
import {
	ContactWrapper,
	ContactHeader,
	ContactContent,
	InfoCard,
	ActionButton,
	SocialLinks,
	ButtonGroup,
} from "./styles";

const Contact = () => {
	const handleCall = () => {
		window.location.href = "tel:+94777715439";
	};

	const handleWhatsApp = () => {
		window.location.href = "https://wa.me/94777715439";
	};

	return (
		<ContactWrapper>
			<ContactHeader>
				<Container>
					<h1>Contact Us</h1>
					<p>Get in touch with us to capture your precious moments</p>
				</Container>
			</ContactHeader>

			<Container>
				<ContactContent>
					<InfoCard>
						<Phone size={24} />
						<div className="info">
							<h3>Call or WhatsApp</h3>
							<p>+94 77 771 5439</p>
							<ButtonGroup>
								<ActionButton onClick={handleCall} variant="outlined">
									<Phone size={18} />
									Call Now
								</ActionButton>
								<ActionButton onClick={handleWhatsApp} variant="primary">
									<MessageCircle size={18} />
									WhatsApp
								</ActionButton>
							</ButtonGroup>
						</div>
					</InfoCard>

					<InfoCard>
						<Mail size={24} />
						<div className="info">
							<h3>Email</h3>
							<p>lepetitbylenscraft@gmail.com</p>
							<ButtonGroup>
								<ActionButton
									as="a"
									href="mailto:lepetitbylenscraft@gmail.com"
									variant="outlined"
								>
									<Mail size={18} />
									Send Email
								</ActionButton>
							</ButtonGroup>
						</div>
					</InfoCard>

					<InfoCard>
						<MapPin size={24} />
						<div className="info">
							<h3>Location</h3>
							<p>
								No. 1013, Maeliya,
								<br />
								Ja-Ela, Sri Lanka
							</p>
						</div>
					</InfoCard>

					<InfoCard>
						<Clock size={24} />
						<div className="info">
							<h3>Business Hours</h3>
							<p>
								Friday: 6:00 AM - 9:00 AM
								<br />
								Weekend: 6:00 AM - 6:00 PM
							</p>
						</div>
					</InfoCard>

					<SocialLinks>
						<h3>Follow Us</h3>
						<div className="social-buttons">
							<ActionButton
								as="a"
								href="https://instagram.com/lepetitpromise"
								target="_blank"
								rel="noopener noreferrer"
								variant="outlined"
							>
								<Instagram size={18} />
								Follow on Instagram
							</ActionButton>
						</div>
					</SocialLinks>
				</ContactContent>
			</Container>
		</ContactWrapper>
	);
};

export default Contact;
